import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationSuccess = ({ email, onContinueToLogin, onGoToDashboard }) => {
  return (
    <div className="clinical-card p-8 text-center">
      {/* Success Icon */}
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <Icon name="CheckCircle" size={48} color="#10b981" />
      </div>

      {/* Success Message */}
      <h1 className="text-3xl font-bold text-foreground mb-3">
        Email Successfully Verified
      </h1>
      
      <p className="text-muted-foreground mb-2">
        Your email address has been confirmed:
      </p>
      
      <p className="text-primary font-semibold mb-6">
        {email}
      </p>

      {/* Account Status Panel */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6 text-left">
        <h2 className="text-lg font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="Info" size={20} color="#3b82f6" />
          Next Steps
        </h2>
        
        <ul className="space-y-3 text-sm text-muted-foreground">
          <li className="flex items-start gap-2">
            <Icon name="Clock" size={16} color="#6b7280" className="mt-0.5 flex-shrink-0" />
            <span>Your account is pending admin review and approval</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Calendar" size={16} color="#6b7280" className="mt-0.5 flex-shrink-0" />
            <span>Review typically takes 24-48 hours</span>
          </li>
          <li className="flex items-start gap-2">
            <Icon name="Mail" size={16} color="#6b7280" className="mt-0.5 flex-shrink-0" />
            <span>You'll receive an email once your account is approved</span>
          </li>
        </ul>
      </div>

      {/* Trust Signals */}
      <div className="flex items-center justify-center gap-4 mb-6 text-xs text-muted-foreground">
        <div className="flex items-center gap-1">
          <Icon name="Shield" size={14} color="#10b981" />
          <span>HIPAA Compliant</span>
        </div>
        <div className="flex items-center gap-1">
          <Icon name="Lock" size={14} color="#10b981" />
          <span>Secure Platform</span>
        </div>
        <div className="flex items-center gap-1">
          <Icon name="CheckCircle" size={14} color="#10b981" />
          <span>Verified Medical Network</span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="space-y-3">
        <button
          onClick={onContinueToLogin}
          className="w-full px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors font-semibold"
        >
          Continue to Login
        </button>
        
        <button
          onClick={onGoToDashboard}
          className="w-full px-6 py-3 bg-background border-2 border-border text-foreground rounded-lg hover:bg-muted transition-colors font-semibold"
        >
          Go to Dashboard
        </button>
      </div>

      {/* Support Contact */}
      <div className="mt-6 pt-6 border-t border-border">
        <p className="text-sm text-muted-foreground mb-2">
          Need assistance?
        </p>
        <a
          href="/contact-support"
          className="text-primary hover:underline font-semibold text-sm"
        >
          Contact Support Team
        </a>
      </div>
    </div>
  );
};

export default VerificationSuccess;